<mat-toolbar class="mat-primary">
  <span fxFlex>{{ data.actionInfo.actionName }}</span>
  <mat-icon class="cursor-mat-element" (click)="cancel()">close</mat-icon>
</mat-toolbar>

<mat-dialog-content style="max-height: 95vh">
  <!-- Use Angular's dynamic component loader -->
  <ng-template customForm></ng-template>
</mat-dialog-content>
